<template>
    <div class="certificate" @click="showCertificate">
      <img v-img :src="certificate.file.url" alt="certificate">
      <div class="overlay">
        <div class="text">{{ certificate.name }}</div>
      </div>

      <!-- BootstrapVue modal -->
      <b-modal no-body size="lg" v-model="modalVisible" title="Certificate Preview" @hidden="closeModal">
        <div class="d-flex align-items-center justify-content-center" >
            <img v-img :src="certificate.file.url" alt="certificate" class="img-fluid">

        </div>
      </b-modal>
    </div>
  </template>

  <script>

  export default {
    name: 'EmployeeCertificate',
    props: {
      certificate: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        modalVisible: false,
      };
    },
    methods: {
      showCertificate() {
        this.modalVisible = true;
      },
      closeModal() {
        this.modalVisible = false;
      },
    },
  };
  </script>

  <style lang="">

  </style>
